import { createAction } from "redux-actions";
import { IImageModal, ISnackbar } from "../../types";

// Action Helpers
const ACTION_PREFIX = "@root";

const getActionName = (name: string) => {
  return `${ACTION_PREFIX}/${name}`;
};

// Actions Name
export const SNACKBAR_ACTION = createAction<ISnackbar>(
  getActionName("SNACKBAR")
);
export const IMAGE_MODAL_ACTION = createAction<IImageModal>(
  getActionName("IMAGE_MODAL")
);
